import gql from 'graphql-tag';

export default gql`
  fragment clientPreleadCustomizeItemSelectOptionFragment on ClientPreleadCustomizeItemSelectOption {
    id
    label
  }
`;
